import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Client } from '../../../client-data/client.model';
import { DocumentReferenceTypesEnum } from '../../../document-data/document-data.data';
import { Billing } from '../../../document-data/sub-models/billing.model';
import { Reference } from '../../../document-data/sub-models/reference.model';
import { CONTENT_KEY } from '../../../entity-data/entity.model';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';
import { ClientPreview } from '../../../tracked-time-data/models/client-preview.model';
import { ClientReference } from '../../../tracked-time-data/models/client-reference.model';
import { TrackedTime } from '../../../tracked-time-data/models/tracked-time.model';

@Injectable()
export class AddTrackedTimeBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    NOTES: 'notes',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(notes: string = ''): FormGroup {
    const formKeys = this.FORM_KEYS;
    const formGroup = {
      [formKeys.NOTES]: [notes, [Validators.maxLength(2900)]],
    };

    return this._formBuilder.group(formGroup);
  }

  buildBilling(
    reference: Reference,
    billingName: string,
    email: string,
    billingAddress: string
  ): Billing {
    return new Billing({
      [Billing.KEYS.NAME]: billingName,
      [Billing.KEYS.EMAIL]: email,
      [Billing.KEYS.ADDRESS]: billingAddress,
      [Billing.KEYS.REFERENCE]: reference,
    });
  }

  buildClientReference(client: Client): Reference {
    return new Reference({
      [Reference.KEYS.TYPE]: DocumentReferenceTypesEnum.client,
      [Reference.KEYS.ID]: client.id,
      [Reference.KEYS.REFERENCE_LOCAL_ID]: client.localId,
      [Reference.KEYS.REVISION_ID]: client.revisionId,
    });
  }

  buildTrackedTime(
    trackedTime: TrackedTime,
    duration: number,
    billing: Billing,
    notes: string
  ) {
    const factor = duration / 60;
    const roundedDuration = Math.round(factor) * 60;
    const billingReference = billing && billing.reference;

    return new TrackedTime({
      ...trackedTime.toJS(),
      [TrackedTime.KEYS.CLIENT_PREVIEW]: {
        [CONTENT_KEY]: billingReference
          ? { [ClientPreview.CONTENT_KEYS.BILLING_NAME]: billing.name || '' }
          : null,
      },
      [CONTENT_KEY]: {
        [TrackedTime.CONTENT_KEYS.START_DATE]: trackedTime.startDate,
        [TrackedTime.CONTENT_KEYS.DURATION]: roundedDuration,
        [TrackedTime.CONTENT_KEYS.NOTES]: notes || '',
        [TrackedTime.CONTENT_KEYS.CLIENT]: billingReference
          ? { [ClientReference.KEYS.REFERENCE]: billingReference.toJS() }
          : null,
      },
    });
  }
}
